import React, { useEffect, useState } from 'react';
import { Table, Button, Input, Form, notification } from 'antd';
import ManageGarmentService from '../../../../../services/ManageGarmentService';

const EditQty = ({ userData, editValue, handleArrowClick }) => {

  const [dataSource, setDataSource] = useState(editValue);
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDataSource(editValue);
  }, [editValue]);

  const tableStyle = {
    backgroundColor: '#9F5375',
    color: '#ffffff',
    padding: '3px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '50%',
    margin: '0 auto',
  };

  const columns = [
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size',
      width: 170,
      render: (text) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <span style={{ fontWeight: 'bold', fontSize: '15px' }}>
            {text}
          </span>
        </div>
      ),
    },
    {
      title: 'Available Quantity',
      dataIndex: 'avilableQty',
      key: 'avilableQty',
      width: 160,
      render: (text) => (
        <div
          style={tableStyle}
        >
          {text}
        </div>
      ),
    },
    {
      title: 'Edit Quantity',
      dataIndex: 'enterQty',
      key: 'enterQty',
      width: 200,
    },
  ];

  const handleSubmit = async () => {

    setLoading(true);
    const updatedData = dataSource.map((item) => {
      if (item.enterQty !== undefined) {
        return {
          ...item,
          // avilableQty: item.enterQty,
        };
      }
      return item;
    });

    const size = updatedData
      .filter((data) => data.enterQty !== undefined)
      .reduce((acc, data) => {
        acc[data.size] = data.enterQty;
        return JSON.stringify(acc);
      }, {});

    // setDataSource(updatedData);

    try {
      const response = await ManageGarmentService.editKanban(size, editValue, userData );

      // Display the success notification
      openNotificationWithIcon('success', response.message);

      setTimeout(() => {
        handleArrowClick();
        setLoading(false);
      }, 800);
    } catch (error) {
      // Handle errors and show an error notification
      console.error('Error submitting EOL dispatch:', error);
      openNotificationWithIcon('error', 'Failed to submit EOL dispatch. Please try again.');
      setLoading(false);
    }
  };


  const openNotificationWithIcon = (type, message) => {
    const messages = {
      error: {
        message: 'Error',
        description: message,
      },
      success: {
        message: 'Success',
        description: message,
      },
      warning: {
        message: 'Warning',
        description: '',
      },
    };

    api[type](messages[type]);
  };

  const columnsWithEditable = columns.map((col) => {
    if (col.dataIndex === 'enterQty') {
      return {
        ...col,
        editable: true,
        render: (_, record) => {
          return (
            <div style={{ width: 90, margin: '0 auto', }}>
              <Input
                value={record.enterQty}
                onChange={(e) => {
                  const value = e.target.value;

                  if (value !== "" && !/^\d*$/.test(value)) {
                    return;
                  }

                  const numericValue = Number(value);

                  if (numericValue < 0) {
                    openNotificationWithIcon("error", "Quantity cannot be negative!");
                    return;
                  }

                  const currentItem = dataSource.find(item => item.key === record.key);

                  if (currentItem && numericValue > currentItem.avilableQty) {
                    openNotificationWithIcon(
                      "error",
                      `Quantity cannot be greater than ${currentItem.avilableQty}`
                    );
                    return;
                  }

                  const updatedData = [...dataSource];
                  const index = updatedData.findIndex(item => item.key === record.key);
                  if (index !== -1) {
                    updatedData[index].enterQty = value;
                    setDataSource(updatedData);
                  }
                }}
                required
              />

            </div>
          );
        },
      };
    }
    return col;
  });

  return (
    <div>
      {contextHolder}
      <Table
        size='small'
        style={{ width: '80%' }}
        dataSource={dataSource}
        columns={columnsWithEditable}
        pagination={false}
        rowClassName="editable-row"
        components={{
          header: {
            cell: (props) => (
              <th
                {...props}
                style={{
                  textAlign: "center",
                }}
              >
                {props.children}
              </th>
            ),
          },
        }}
        footer={() => (
          dataSource.length > 0 ? (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                type="primary"
                style={{ marginRight: '8px' }}
                onClick={handleSubmit}
                loading={loading}
              >
                Submit
              </Button>
              <Button onClick={handleArrowClick}>Cancel</Button>
            </div>
          ) : null
        )}
      />
    </div>
  );
};

export default EditQty;